<template>
  <div>
    <div style="width:300px;margin-bottom:12px">
      <el-input
        clearable
        @clear="searchChange"
        :placeholder="this.$t('common.searchValue')"
        v-model.trim="searchFrom.searchText"
        @keyup.enter.native="searchChange"
      >
        <el-button
          @click="searchChange"
          slot="append"
          icon="el-icon-search"
        ></el-button>
      </el-input>
    </div>

    <ZKtecoTable
      ref="firmwareTable"
      :queryParams="searchFrom"
      tableId="firmware_fist_table"
      :columns="employeeColumns"
      dataUrl="/apiv1/hr/employee/findByCompanyIdV2"
    >
      <template v-slot:bio="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="
            scope.row.fingerCount > 0
              ? $t('employee.enteredFingerprint')
              : $t('employee.notEnteredFingerprint')
          "
          placement="bottom"
        >
          <i
            v-bind:class="{ active: scope.row.fingerCount > 0 }"
            class="bio-icon-cla zk-icon-ic_zw-"
          ></i>
        </el-tooltip>

        <el-popover
          v-if="scope.row.visibleLightFaceCount > 0"
          placement="bottom"
          trigger="hover"
          width="160"
          @show="show(scope.row)"
          @hide="hide()"
        >
          <div style="text-align: right; margin: 0">
            <el-image :src="imageUrl"></el-image>
          </div>
          <i slot="reference" class="bio-icon-cla active zk-icon-ic_rl"></i>
        </el-popover>

        <el-tooltip
          v-else-if="scope.row.visibleLightFaceCount === 0"
          class="item"
          effect="dark"
          :content="$t('employee.enteredVisibleLight')"
          placement="bottom"
        >
          <i class="bio-icon-cla zk-icon-ic_rl"></i>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          :content="
            scope.row.faceCount > 0
              ? $t('employee.enteredNirFace')
              : $t('employee.notEnteredNirFace')
          "
          placement="bottom"
        >
          <i
            v-bind:class="{ active: scope.row.faceCount > 0 }"
            class="bio-icon-cla zk-icon-nirFace"
          ></i>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          :content="
            scope.row.palmPrintCount > 0
              ? $t('employee.enteredPalmPrint')
              : $t('employee.notEnteredPalmPrint')
          "
          placement="bottom"
        >
          <i
            v-bind:class="{ active: scope.row.palmPrintCount > 0 }"
            class="bio-icon-cla zk-icon-ic_zw"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:operator="scope">
        <el-button @click="employeeDetails(scope.row)" type="text">{{
          $t('common.details')
        }}</el-button>
      </template>
    </ZKtecoTable>
  </div>
</template>

<script>
import { commonRequest } from '@/services/baseRequst.js'
export default {
  props: {
    currentRow: {
      type: Object,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    if (this.currentRow) {
      this.searchFrom.companyId = this.currentRow.id
    }
  },
  data() {
    return {
      imageUrl: '',
      searchFrom: {
        companyId: '',
        searchText: ''
      },
      employeeColumns: [
        { label: this.$t('employee.employeeNo'), prop: 'employeeNo' },
        { label: this.$t('employee.formattedName'), prop: 'formattedName' },
        { label: this.$t('device.biosignature'), prop: 'bio', slot: 'bio' },
        { label: this.$t('employee.badgeNo'), prop: 'idCard' },
        { label: this.$t('common.action'), prop: 'operator', slot: 'operator' }
      ]
    }
  },
  methods: {
    employeeDetails(row) {
      this.$router.push({
        path: '/tenantManager/employeeDetail',
        query: { employeeId: row.id, companyId: row.companyId }
      })
    },
    searchChange() {
      this.$refs.firmwareTable.loadData({}, true)
    },
    show(row) {
      let url = sessionStorage.getItem(row.faceUrl)
      if (url) {
        this.imageUrl = url
        return false
      }
      commonRequest('/apiv1/hr/employee/findFileByFaceUrl', {
        faceUrl: row.faceUrl
      })
        .then(data => {
          try {
            let result = data.payload.params
            this.imageUrl = result.imagePrefix + result.imageFile
            sessionStorage.setItem(row.faceUrl, this.imageUrl)
          } catch (error) {
            this.errorMessage(error)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    hide() {
      this.imageUrl = ''
    }
  }
}
</script>

<style scoped lang="less">
.active {
  color: #78bc27;
}
.bio-icon-cla {
  margin-right: 20px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/detailPage/companyEmployee.vue